import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ShowChart as ChartIcon, List as ListIcon } from '@mui/icons-material';
import Tile from '../Tile/Tile';
import Loading from '../Loading/Loading';
import DialogWrapper from '../DialogWrapper/DialogWrapper';
import Subreport from '../../../pages/InstrumentDetails/components/InstrumentTelemetry/components/Subreport/Subreport';
import { filter, groupBy, map } from 'lodash';
import ChartAdapter from './components/DisplayComponents/ChartAdapter';
import FilterAdapter from './components/DisplayComponents/FilterAdapter';
import ListAdapter from './components/DisplayComponents/ListAdapter';
import TableAdapter from './components/DisplayComponents/TableAdapter';
import HtmlAdapter from './components/DisplayComponents/HtmlAdapter';
import ChartWithSliderAdapter from './components/DisplayComponents/ChartWithSliderAdapter';
import './ReportRenderer.css';

const ReportItemGroup = (props) => (
  <Tile
    className="u-mb-full"
    title={props.title}
    helpTag={`report-${props.query.ReportName}-tile-${props.title}`}
  >
    {props.reportItemRows.map((itemRow, index) => (
      <ReportItemRow
        reportItems={itemRow.items}
        query={props.query}
        onQueryChanged={props.onQueryChanged}
        isFetching={props.isFetching}
        key={index}
        onReportItemEvent={props.onReportItemEvent}
      />
    ))}
  </Tile>
);

const ReportItemRow = (props) => (
  <div className="u-fx u-fx-space-between">
    {props.reportItems.map((item, index) => (
      <ReportItem
        settings={item}
        query={props.query}
        onQueryChanged={props.onQueryChanged}
        isFetching={props.isFetching}
        key={index}
        onReportItemEvent={props.onReportItemEvent}
      />
    ))}
  </div>
);

const ReportItem = (props) => (
  <section
    style={{ width: props.settings.Layout.Width || '100%' }}
    data-qa={`qa-section-${props.settings.Type}-${props.settings.Name}`}
  >
    <ReportItemSwitcher
      settings={props.settings}
      query={props.query}
      onQueryChanged={props.onQueryChanged}
      isFetching={props.isFetching}
      onReportItemEvent={props.onReportItemEvent}
    />
  </section>
);

const ReportItemSwitcher = (props) => {
  switch (props.settings.Type) {
    case 'Filter':
      return (
        <FilterAdapter
          settings={props.settings}
          query={props.query}
          onQueryChanged={props.onQueryChanged}
          isFetching={props.isFetching}
        />
      );
    case 'Chart':
      return <ChartAdapter settings={props.settings} />;
    case 'Table':
      return (
        <TableAdapter
          settings={props.settings}
          query={props.query}
          onReportItemEvent={props.onReportItemEvent}
          isFetching={props.isFetching}
        />
      );
    case 'List':
      return (
        <ListAdapter
          settings={props.settings}
          query={props.query}
          onQueryChanged={props.onQueryChanged}
        />
      );
    case 'ChartWithSlider':
      return (
        <ChartWithSliderAdapter
          settings={props.settings}
          query={props.query}
          onQueryChanged={props.onQueryChanged}
        />
      );
    case 'Html':
      return (
        <HtmlAdapter
          settings={props.settings}
          query={props.query}
          onQueryChanged={props.onQueryChanged}
        />
      );
    default:
      return null;
  }
};

const groupDiplayComponents = (displayComponents) => {
  var filtered = filter(displayComponents, (dc) => dc.Layout);
  var groupedData = groupBy(filtered, (dc) => dc.Layout.Group);
  var rowedData = map(groupedData, (itemsInGroup, groupName) => {
    var itemsByRow = groupBy(itemsInGroup, (dc) => dc.Layout.Row);
    var rows = map(itemsByRow, (itemsInRow, row) => ({
      row: row,
      items: itemsInRow,
    }));
    return {
      groupName: groupName,
      rows: rows,
    };
  });
  return rowedData;
};

const formatJson = (object) => {
  if (!object || typeof object !== 'object') {
    return <>"{object}"</>;
  }

  let listItems = Object.keys(object).map((key, index) => {
    return object.hasOwnProperty(key) ? (
      <li key={index}>
        {key} = {formatJson(object[key])}
      </li>
    ) : null;
  });

  return (
    <>
      <ul>{listItems}</ul>
    </>
  );
};

class ReportRenderer extends PureComponent {
  render() {
    return (
      <div className="instrument-report">
        {/*formatJson(this.props.query)*/}
        <Loading
          condition={
            this.props.isFetching &&
            (!this.props.displayComponents || this.props.displayComponents.length === 0)
          }
        >
          <DialogWrapper
            onClickCancel={this.props.subreportConfig.dialogSubreport.onClose}
            open={this.props.subreportConfig.dialogSubreport.open}
            title="Chart"
            hideMainAction={true}
            maxWidth={'xl'}
          >
            <Subreport
              subreportParams={
                this.props.subreportConfig ? this.props.subreportConfig.dialogSubreport.args : null
              }
            />
          </DialogWrapper>
          {groupDiplayComponents(this.props.displayComponents).map((group, index) => (
            <ReportItemGroup
              title={group.groupName}
              query={this.props.query}
              reportItemRows={group.rows}
              onQueryChanged={this.props.onQueryChanged}
              isFetching={this.props.isFetching}
              key={index}
              onReportItemEvent={this.props.onReportItemEvent}
            />
          ))}
        </Loading>
      </div>
    );
  }
}

ReportRenderer.propTypes = {
  query: PropTypes.object,
  onQueryChanged: PropTypes.func,
  displayComponents: PropTypes.array,
  isFetching: PropTypes.bool,
};

ReportRenderer.defaultProps = {
  query: {},
  onQueryChanged: () => {},
  displayComponents: [],
  isFetching: false,
};

export default ReportRenderer;
